import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Navbar from "../../components/landing/Navbar";
import Footer from "../../components/landing/Footer";
import { CommonBlockRenderer } from "../../components/commonBlockRenderer";
import DocsContentSpinner from "../../components/docs/DocsContentSpinner";
import DocsUnavailable from "../../components/docs/DocsUnavailable";
import {
  getLocalLegalDocumentConfig,
  loadLegalDocumentForPage,
} from "../../utils/api/legal_apis";
import { isLegalLocalMode } from "../../pages/docs/constants/legalEnv";
import { isRenderableSectionConfig } from "../../utils/docUtils/docsSectionUtils";
import pageStyles from "../../styles/docs/docsPage.module.scss";

function resolvePageState(config) {
  if (!isRenderableSectionConfig(config)) {
    return { status: "error", config: null };
  }
  return { status: "ready", config };
}

function getInitialPageState(documentType) {
  if (!isLegalLocalMode()) {
    return { status: "loading", config: null };
  }
  return resolvePageState(getLocalLegalDocumentConfig(documentType));
}

const LegalDocumentPage = ({ documentType }) => {
  const location = useLocation();
  const [state, setState] = useState(() => getInitialPageState(documentType));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [documentType, location.pathname]);

  useEffect(() => {
    if (isLegalLocalMode()) {
      setState(resolvePageState(getLocalLegalDocumentConfig(documentType)));
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      setState({ status: "loading", config: null });
      const contentResult = await loadLegalDocumentForPage(documentType);

      if (cancelled) {
        return;
      }

      if (!contentResult.ok) {
        setState({ status: "error", config: null });
        return;
      }

      setState(resolvePageState(contentResult.data));
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [documentType]);

  return (
    <div className="landing-page min-h-screen bg-background">
      <Navbar />
      <main className={pageStyles.main}>
        <div className={pageStyles.contentWrapper}>
          <Box maxWidth="800px" mx="auto" py={4} px={2}>
            {state.status === "loading" && <DocsContentSpinner />}
            {state.status === "error" && <DocsUnavailable />}
            {state.status === "ready" && <CommonBlockRenderer section={state.config} />}
          </Box>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalDocumentPage;
